// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u0XtB","textarea":"styles_textarea__3rTMJ"};